import { Dispatch } from "@reduxjs/toolkit";
import {
  clearAllTimeUnitsData,
  clearFilterBizLayerQueryDataMap,
  clearTrendsFilters,
  setActivityNotesDataGlobal,
  setDefaultDimension,
  setDefaultWebsiteUid,
  setSelectedSharedUid,
  setSelectedTimeUnit,
  setShowTrendsTabs,
  setTrendsDashboardExecuteQueriesData,
} from "../../../../../../features/trendsSlice";

const SELECT_ALL_OPTION = { uid: "select_all", siteName: "Select All" };

export const getAutocompleteOptions = (
  fetchBy: string,
  siteOptions: any[],
  dimensionOptions: string[],
  organizationDimensions: any[],
  selectedValues: any[] = []
) => {
  let baseOptions = [];

  switch (fetchBy) {
    case "site":
      baseOptions = siteOptions;
      break;
    case "dimension":
      baseOptions = dimensionOptions.map((dim: string) => ({
        uid: dim,
        siteName: dim,
      }));
      break;
    case "organization":
      baseOptions = organizationDimensions;
      break;
    default:
      baseOptions = [];
  }

  // Add SELECT_ALL_OPTION for all cases where we have options
  const selectedUids = selectedValues.map((item) => item.uid);
  const filteredOptions = baseOptions.filter(
    (option) => !selectedUids.includes(option.uid)
  );
  if (
    filteredOptions.length > 0 &&
    !selectedUids.includes(SELECT_ALL_OPTION.uid)
  ) {
    return [SELECT_ALL_OPTION, ...filteredOptions];
  }

  return filteredOptions;
};

export const handleAutocompleteChange = (
  newValue: any,
  fetchBy: string,
  searchParams: URLSearchParams,
  dispatch: Dispatch,
  setValue: (val: number) => void,
  setSearchParams: (params: URLSearchParams) => void,
  datesDefault: any[],
  siteOptions: any[],
  dimentionOptions: string[],
  organizationDimensions: any[]
) => {
  let uid = [];
  const options = getAutocompleteOptions(
    fetchBy,
    siteOptions,
    dimentionOptions,
    organizationDimensions
  );
  if (newValue.some((item: any) => item.uid === SELECT_ALL_OPTION.uid)) {
    // For all fetchBy cases, filter out "Select All" from the final selection
    uid = options
      .filter((option) => option.uid !== SELECT_ALL_OPTION.uid)
      .map((option) => option.uid);
  } else {
    uid = newValue?.map((item: any) => item.uid) || [];
  }
  dispatch(setSelectedSharedUid(uid));
  dispatch(setShowTrendsTabs(false));
  setValue(0); // Reset to the first tab
  dispatch(setSelectedTimeUnit(datesDefault[0])); // Reset time unit to default
  dispatch(clearAllTimeUnitsData());
  const newParams = new URLSearchParams(searchParams);

  if (uid.length > 0) {
    if (fetchBy === "site") {
      newParams.set("selectedSite", uid);
      newParams.delete("dimension");
      newParams.delete("fetchBy");
    } else if (fetchBy === "dimension") {
      newParams.set("dimension", uid);
      newParams.delete("selectedSite");
      newParams.delete("fetchBy");
    }
  } else {
    newParams.delete("selectedSite");
    newParams.delete("dimension");
    newParams.delete("fetchBy");
  }

  newParams.delete("tab");
  newParams.delete("timeUnit");
  newParams.delete("dataSet");
  newParams.delete("view-Trends");
  newParams.delete("graph");

  const filterParamKeys = [
    "trafficSource",
    "campaignId",
    "adgroupId",
    "kwId",
    "country",
  ];

  filterParamKeys.forEach((key) => newParams.delete(key));
  [...newParams.keys()].forEach((key) => {
    if (key.includes("timeUnit")) {
      newParams.delete(key);
    }
  });
  setSearchParams(newParams);
};

export const handleClearAutocomplete = (dispatch: Dispatch) => {
  dispatch(setShowTrendsTabs(false));
  dispatch(setTrendsDashboardExecuteQueriesData([]));
  dispatch(setActivityNotesDataGlobal([]));
  dispatch(clearTrendsFilters());
  dispatch(clearFilterBizLayerQueryDataMap());
  dispatch(clearAllTimeUnitsData());
  dispatch(setDefaultWebsiteUid(null));
  dispatch(setDefaultDimension(null));
};

export { SELECT_ALL_OPTION };
